<template>
  <v-app
    :class="$store.getters.LANGUAGE == 'fa' ? 'vazir-font-fd' : 'vazir-font'"
  >
    <v-main>
      <span class="bg"></span>
      <public-logo></public-logo>
      <router-view></router-view>
    </v-main>
    <v-footer>
      <div
        class="text-center mx-auto"
        v-html="$vuetify.lang.translator('copyright')"
      ></div>
    </v-footer>
  </v-app>
</template>

<script>
import PublicLogo from "@/components/PublicLogo";

export default {
  name: "PublicLayout",
  components: {
    PublicLogo
  }
};
</script>

<style>
.bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: url("/static/img/background.jpg") no-repeat center center;
  background-size: cover;
  transform: scale(1.1);
}
</style>
